import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";

@JsonConverter
export class CountersConverter implements JsonCustomConvert<Counters>{
	serialize() { }
	deserialize(data: any): Counters {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Counters);
	}
}


@JsonObject("Counters")
export class Counters {
    @JsonProperty("count", Number, true)
	count: number = 0;
    @JsonProperty("online", Number, true)
	online: number = 0;
    @JsonProperty("offline", Number, true)
	offline: number = 0;
    @JsonProperty("pending", Number, true)
	pending: number = 0;
}

@JsonObject("CountersData")
export class CountersData extends BaseResponse{
	@JsonProperty("data", CountersConverter, true)
	data:Counters = new Counters();
}